import React, { useState, useEffect } from 'react';
import styles from './FloatingLanguageSwitcher.module.css';

const FloatingLanguageSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('fa');

  // Read language from localStorage on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('siteLanguage') || 'fa';
    setCurrentLanguage(savedLanguage);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageSelect = (lang) => {
    // Save to localStorage
    localStorage.setItem('siteLanguage', lang);
    
    // Update HTML attributes
    document.documentElement.lang = lang;
    document.documentElement.dir = 'rtl';
    
    // Close menu
    setIsOpen(false);
    
    // Reload page to apply changes
    window.location.reload();
  };

  const getLanguageLabel = (lang) => {
    return lang === 'fa' ? 'FA' : 'AR';
  };

  return (
    <div className={styles.floatingContainer}>
      {/* Main Button */}
      <button
        className={`${styles.mainBtn} ${isOpen ? styles.open : ''}`}
        onClick={toggleMenu}
        aria-label={isOpen ? 'بستن منوی زبان' : 'باز کردن منوی زبان'}
      >
        {isOpen ? '✕' : getLanguageLabel(currentLanguage)}
      </button>

      {/* Language Options */}
      <div className={`${styles.optionsContainer} ${isOpen ? styles.visible : ''}`}>
        <button
          className={`${styles.optionBtn} ${currentLanguage === 'fa' ? styles.active : ''}`}
          onClick={() => handleLanguageSelect('fa')}
          aria-label="تغییر به فارسی"
        >
          <span className={styles.optionLabel}>فارسی</span>
          <span className={styles.optionCode}>FA</span>
        </button>
        
        <button
          className={`${styles.optionBtn} ${currentLanguage === 'ar' ? styles.active : ''}`}
          onClick={() => handleLanguageSelect('ar')}
          aria-label="تغییر به عربی"
        >
          <span className={styles.optionLabel}>العربية</span>
          <span className={styles.optionCode}>AR</span>
        </button>
      </div>

      {/* Backdrop */}
      {isOpen && (
        <div 
          className={styles.backdrop} 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default FloatingLanguageSwitcher;
